import { Component, Prop, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { loadLanguageAsync } from '@/i18n';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
import { languageOptions } from '@/support/Languages';
import router from '@/router';

@Component<LanguageSwitch>({
  components: {
    PageHeader,
  },
})
export default class LanguageSwitch extends Vue {
  @Prop({ required: true })
  protected user!: User;

  protected selectedLanguage: string | undefined = '';
  protected isLoading = false;
  protected languageOptions = languageOptions;

  protected mounted(): void {
    this.selectedLanguage = this.user.language || 'en';
  }

  public async changeLanguage(languageCode: string): Promise<void> {
    if (!languageCode) {
      return;
    }

    try {
      this.isLoading = true;
      await loadLanguageAsync(languageCode);
      if (this.user) {
        const payload = { language: languageCode };
        await this.user.update(payload);
      }

      await router.push({
        path: router.currentRoute.path,
        query: {
          ...router.currentRoute.query,
          lang: languageCode,
        },
      });
    } catch (error) {
      ErrorHandler.network(error);
    } finally {
      this.isLoading = false;
    }
  }
}
